import { type Dispatch, type FC, useEffect } from "react";

import { useFormikContext } from "formik";

export const FormChangesListener: FC<{
  onValuesChange?: (parameters: any) => void;
  onValidityChange?: Dispatch<boolean>;
  ignoreDirty?: boolean;
}> = ({ onValuesChange, onValidityChange, ignoreDirty = false }) => {
  const { dirty, isValid, values } = useFormikContext();

  useEffect(() => {
    (ignoreDirty || dirty) && onValuesChange?.(values);
    onValidityChange?.(isValid);
  }, [dirty, values, onValuesChange, ignoreDirty, onValidityChange, isValid]);

  useEffect(() => {
    onValidityChange?.(isValid);
  }, [isValid, onValidityChange]);

  return null;
};
